import { render } from "./BaseNav.vue?vue&type=template&id=59f5ea23"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Navbar/BaseNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f5ea23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f5ea23', __exports__)) {
    api.reload('59f5ea23', __exports__)
  }
  
  module.hot.accept("./BaseNav.vue?vue&type=template&id=59f5ea23", () => {
    api.rerender('59f5ea23', render)
  })

}


export default __exports__